import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { SwitchPage } from './pages/SwitchPage';
import { PricingPage } from './pages/PricingPage';
import { DocsPage } from './pages/DocsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
import { BlogArticlePage } from './pages/BlogArticlePage';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/about" element={<AboutPage data-id="element-5" />} data-id="element-4" />
        <Route path="/switch" element={<SwitchPage data-id="element-7" />} data-id="element-6" />
        <Route path="/blog" element={<BlogPage data-id="element-9" />} data-id="element-8" />
        <Route path="/blog/:slug" element={<BlogArticlePage data-id="element-11" />} data-id="element-10" />
        <Route path="/pricing" element={<PricingPage data-id="element-13" />} data-id="element-12" />
        <Route path="/docs" element={<DocsPage data-id="element-15" />} data-id="element-14" />
        <Route path="/privacy" element={<PrivacyPage data-id="element-17" />} data-id="element-16" />
        <Route path="/terms" element={<TermsPage data-id="element-19" />} data-id="element-18" />
        <Route path="/contact" element={<ContactPage data-id="element-21" />} data-id="element-20" />
      </Routes>
    </>;
}